export const convertBytes = {
  data() {
    return {};
  },
  methods: {
    convertBytesMethod(sizeInBytes) {
      if (!sizeInBytes) return "-";
      const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      let unitIndex = 0;

      while (sizeInBytes >= 1024 && unitIndex < units.length - 1) {
        sizeInBytes /= 1024;
        unitIndex++;
      }

      return `${sizeInBytes.toFixed(2)} ${units[unitIndex]}`;
    },
  },
};
